module.exports = __webpack_public_path__ + "img/black_info.7cff0ab6.png";